import {
  Component,
  DestroyRef,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BoardService } from '../../../../services/board.service';
import { Call } from '../../board-v3.types';

@Component({
  selector: 'app-board-v3-call-transcript',
  templateUrl: './call-transcript.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  host: { class: 'block h-full min-h-0' },
})
export class CallTranscriptComponent implements OnChanges {
  @Input() callId: string | null = null;

  @Output() close = new EventEmitter<void>();

  private readonly boardService = inject(BoardService);
  private readonly destroyRef = inject(DestroyRef);

  call: Call | null = null;
  loading = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['callId'] && this.callId) this.loadCall();
  }

  loadCall(): void {
    if (!this.callId) return;

    this.loading = true;
    this.call = null;
    this.boardService
      .getCall(this.callId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (call) => {
          this.call = call;
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        },
      });
  }

  get utterances() {
    return this.call?.transcript_utterances ?? [];
  }

  get firstSpeaker(): string | undefined {
    return this.utterances[0]?.speaker;
  }

  isOwnMessage(speaker: string): boolean {
    return speaker === this.firstSpeaker;
  }

  formatTimestamp(ms: number): string {
    const totalSeconds = Math.round((ms || 0) / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    return `${minutes}:${String(seconds).padStart(2, '0')}`;
  }

  onCancel(): void {
    this.close.emit();
  }
}
